import { AttachmentViewPoint } from './attachment-viewpoint.enum';
import {ReportViewPoint} from '@docma-mm-core/report-template/report-template';

export enum ViewPoint {
  None = 0,
  Contractor = 1, // CO (AN)
  Customer = 2, // CT (AG)
  Subcontractor = 4 // SC (NU)
}
export function convertToAttachmentViewPoint(viewPoint: ViewPoint) {

  switch (viewPoint) {
    case ViewPoint.Contractor:
      return AttachmentViewPoint.Contractor;
      break;
    case ViewPoint.Customer:
      return AttachmentViewPoint.Customer;
      break;
    case ViewPoint.Subcontractor:
      return AttachmentViewPoint.Subcontractor;
      break;
  }
  return AttachmentViewPoint.None;
}

export function convertToReportViewPoint(viewPoint: ViewPoint) {

  switch (viewPoint) {
    case ViewPoint.Contractor:
      return ReportViewPoint.Contractor;
      break;
    case ViewPoint.Customer:
      return ReportViewPoint.Customer;
      break;
    case ViewPoint.Subcontractor:
      return ReportViewPoint.Subcontractor;
      break;
  }
  return ReportViewPoint.None;
}
